import A from 'actions/provider/providerActions';

const init = {
    showCaptcha: false,
    allowSubmit: false,
    loadingSchools: false,
    schoolList: [],
    invalidEmailError: false,
    faaCertError: false
};

export default (state=init, action) => { switch(action.type) {
    case A.PROVIDER_TOGGLE_CAPTCHA_VIEW: return {...state, 
        showCaptcha: action.payload != null
            ? action.payload
            : !state.showCaptcha
    };

    case A.PROVIDER_TOGGLE_ALLOW_SUBMIT: return {...state, 
        allowSubmit: action.payload != null
            ? action.payload
            : !state.allowSubmit
    };

    case A.LOAD_ALL_SCHOOLS_REQUEST: return {...state,
        loadingSchools: true
    };

    case A.LOAD_ALL_SCHOOLS_SUCCESS: return {...state,
        loadingSchools: false,
        schoolList: action.payload.organizations
    };

    case A.LOAD_ALL_SCHOOLS_FAILURE: return {...state,
        loadingSchools: false
    };

    case A.TOGGLE_INVALID_PROVIDER_EMAIL_ERROR: return {...state, 
        invalidEmailError: !state.invalidEmailError 
    };
    case A.TOGGLE_PROVIDER_FAA_CERT_ERROR: return {...state,
        faaCertError: !state.faaCertError
    };

    default: return {...state};
}}
